import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Download, X } from 'lucide-react';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      const dismissed = sessionStorage.getItem('pwa_dismissed');
      if (!dismissed) setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowBanner(false);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    sessionStorage.setItem('pwa_dismissed', '1');
  };

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-16 lg:bottom-4 left-4 right-4 z-50 bg-[#0D2850] text-white rounded-xl p-4 shadow-2xl flex items-center gap-3 animate-in slide-in-from-bottom-4"
      data-testid="pwa-install-prompt"
    >
      <div className="w-10 h-10 rounded-lg bg-[#F5CB08] flex items-center justify-center shrink-0">
        <Download className="w-5 h-5 text-[#0D2850]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Install Prismoline</p>
        <p className="text-xs text-white/70">Add to home screen for quick access</p>
      </div>
      <Button
        size="sm"
        className="bg-[#F5CB08] text-[#0D2850] hover:bg-[#e5bb00] font-semibold shrink-0"
        onClick={handleInstall}
        data-testid="pwa-install-btn"
      >
        Install
      </Button>
      <button
        onClick={handleDismiss}
        className="text-white/50 hover:text-white p-1"
        data-testid="pwa-dismiss-btn"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
